import { css } from "@emotion/react";
import { useAccount, useConnect } from "wagmi";

interface ConnectWalletPopupProps {
  open: boolean;
  close: () => void;
}

const ConnectWalletPopup: React.FC<ConnectWalletPopupProps> = ({
  open,
  close,
}) => {
  const { isConnected } = useAccount();
  const { connect, connectors, isLoading, pendingConnector } = useConnect();
  return open && !isConnected ? (
    <div
      css={[
        css`
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.8);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        `,
      ]}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          close();
        }
      }}
    >
      <div
        css={css`
          background-color: #fff;
          border-radius: 3px;
          width: 60%;
          max-width: 400px;
          padding: 16px 24px;
          text-align: center;
        `}
      >
        <span
          css={css`
            font-family: "Bebas Neue", cursive;
            font-size: 24px;
          `}
        >
          Connect Wallet
        </span>
        <div
          css={css`
            display: flex;
            justify-content: center;
            gap: 16px;
            padding-top: 16px;
            @media (max-width: 1024px) {
              flex-direction: column;
            }
          `}
        >
          {connectors.map((connector) => (
            <button
              css={css`
                background-color: #fff;
                color: #d65b56;
                border: 1px solid #d65b56;
                border-radius: 3px;
                padding: 8px 16px;
                font-weight: 600;
                transition: opacity 0.3s;
                cursor: pointer;

                &:hover {
                  opacity: 0.3;
                }
              `}
              disabled={!connector.ready}
              key={connector.id}
              onClick={() => {
                connect({ connector });
                close();
              }}
            >
              {connector.name}
              {!connector.ready && " (unsupported)"}
              {isLoading &&
                connector.id === pendingConnector?.id &&
                " (connecting)"}
            </button>
          ))}
          {
            // @ts-ignore
            !window.ethereum?.isMetaMask && (
              <div
                css={css`
                  display: none;
                  @media (max-width: 830px) {
                    display: block;
                  }
                `}
              >
                <p style={{ textAlign: "center", marginBottom: 16 }}>or</p>
                <button
                  css={css`
                    background-color: #fff;
                    color: #d65b56;
                    border: 1px solid #d65b56;
                    border-radius: 3px;
                    padding: 8px 16px;
                    font-weight: 600;
                    transition: opacity 0.3s;
                    width: 100%;
                    cursor: pointer;

                    &:hover {
                      opacity: 0.3;
                    }
                  `}
                  onClick={() => {
                    window.open(
                      `https://metamask.app.link/dapp/${window.location.host}/#/`
                    );
                  }}
                  style={{ marginBottom: 40 }}
                >
                  Use MetaMask App
                </button>
              </div>
            )
          }
        </div>
      </div>
    </div>
  ) : null;
};

export default ConnectWalletPopup;
